const nebulaBrainDailyTradeMenuRegistry = {};

export default nebulaBrainDailyTradeMenuRegistry;
